export default "__VITE_ASSET__C79BHZOk__"